import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/** One key per user intent: a double click sends the same key, the server returns one job. */
export const newKey = (): string => crypto.randomUUID();
